!window.$EComjQuery &&
  window.jQuery &&
  (window.$EComjQuery = jQuery.noConflict()),
  function () {
    "lightbox" === this.settings.link &&
      "yes" === this.settings.lightbox &&
      window.$EComjQuery.fn.ecomPopup &&
      window
        .$EComjQuery(this.$el)
        .find("[data-ecom-popup]")
        .ecomPopup({ type: "image" });
  }.call({
    $el: document.querySelector(".ecom-svm9d6es"),
    settings: { link: "custom", lightbox: "no" },
    id: "ecom-svm9d6es",
    isLive: !0,
  }),
  function () {
    "lightbox" === this.settings.link &&
      "yes" === this.settings.lightbox &&
      window.$EComjQuery.fn.ecomPopup &&
      window
        .$EComjQuery(this.$el)
        .find("[data-ecom-popup]")
        .ecomPopup({ type: "image" });
  }.call({
    $el: document.querySelector(".ecom-lac8m0vv"),
    settings: { link: "custom", lightbox: "no" },
    id: "ecom-lac8m0vv",
    isLive: !0,
  }),
  function () {
    "lightbox" === this.settings.link &&
      "yes" === this.settings.lightbox &&
      window.$EComjQuery.fn.ecomPopup &&
      window
        .$EComjQuery(this.$el)
        .find("[data-ecom-popup]")
        .ecomPopup({ type: "image" });
  }.call({
    $el: document.querySelector(".ecom-hoc9x6ge"),
    settings: { link: "custom", lightbox: "no" },
    id: "ecom-hoc9x6ge",
    isLive: !0,
  }),
  window.addEventListener("load", () => {
    let e = !1;
    document.querySelector("#admin-bar-iframe") && (e = !0);
    let t = document.querySelector("body"),
      o = document.createElement(
        Math.random().toString(36).replace(/\d*/g, "").substr(2, 4)
      );
    o.setAttribute(
      "style",
      [
        "position:relative",
        "top: 0px",
        "left: 0px",
        "display: inline-block",
        "height: 30px",
        "line-height: 30px",
        "font-size: 15px",
        "width: 100%",
        "text-align: center",
        "opacity: 1",
        "text-indent: 0",
        "color: #333",
        "background: #fff",
        "",
      ].join(" !important;")
    ),
      (o.innerHTML =
        'Made with &hearts; by <a href="https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content=' +
        window.location.origin +
        '" target="_blank">EComposer</a>' +
        (e ? ". Contact us or upgrade to remove branding" : "")),
      t.appendChild(o);
  });
